<template>
  <div class="wrapper">
  <CustomDialog
    style="font-family: 'Be Vietnam Pro Medium'"
    :openDialog="isOpen"
    :widthDialog="'543px'"
    :classDialog="'custom-loading-dialog'"
    :closeOnClickModal="false"
    :closeOnPressEscape="false"
    :showCloseBtn="true"
    @closed="$emit('closed')"
    @closeDialog="$emit('closed')"
  >

  <template #header>
    <div class="title">
      <span>Xác thực ký số</span>
    </div>
    </template>

    <template #body>
      <p class="loading-message">Vui lòng kiểm tra và thực hiện xác thực trên:</p>
      <div class="flex-col margin-left-20 transaction-details">
        <span>{{ `Id giao dịch: ${transactionId || 'Đang lấy thông tin'}` }}</span>
        <span>{{ `Thiết bị: ${deviceName || 'Đang lấy thông tin'}` }}</span>
        <span>{{ `Tài khoản: ${usernameIdp || 'Đang lấy thông tin'}` }}</span>
      </div>
      <div class="remainingTime">
        <span>
          Hết hạn sau:<span class="time"> {{`${remainingTime || 'Đang lấy thông tin'}`}}</span>
        </span>
      </div>
    </template>
  </CustomDialog>
  </div>
</template>

<script>
import CustomDialog from "../../../common/custom-dialog.vue";

export default {
  name: 'loading',
  props: ['isOpen', 'transactionId', 'deviceName', 'usernameIdp', 'remainingTime'],
  components: {
    CustomDialog
  }
}
</script>

<style scoped>
.title {
  text-align: center;
  padding-top: 20px;
  font: bold 24px "Be Vietnam Pro Medium";
  color: #27BDBE;
}

.loading-message {
  text-align: center;
  font: normal 16px "Be Vietnam Pro Medium";
  color: black;
  margin-top: 6px;
}

.transaction-details {
  padding-left: 20%;
  padding-top: 5px;
  color: black;
  font-size: 15px;
}

.remainingTime {
  text-align: center;
  color: #27BDBE;
  padding-top: 25px;
  padding-bottom: 20px;
}

.time {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/office/doc/components/loading.vue